import React from 'react';

function ClockIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <path
        d="M8,0C3.589,0,0,3.589,0,8s3.589,8,8,8s8-3.589,8-8S12.411,0,8,0z M8,15c-3.859,0-7-3.141-7-7s3.141-7,7-7s7,3.141,7,7S11.859,15,8,15z"
      />
      <path
        d="M12.5,8H8V3.5C8,3.224,7.776,3,7.5,3S7,3.224,7,3.5v5C7,8.776,7.224,9,7.5,9h5C12.776,9,13,8.776,13,8.5S12.776,8,12.5,8z"
      />
    </svg>
  );
}

export default ClockIcon;
